import React from "react"
import Wrapper from "../components/Wrapper/Wrapper"
import "../scss/main.scss"
import Home from "./Home/Home"
import './fontCss.css'

const Index = () => {
  return (
    <Wrapper>
      <Home />
    </Wrapper>
  )
}

export default Index
